/**
* Visual Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Visual Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {

    className: 'visual-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function( ) {
      const _this = this;
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '.btn-primary, .btn-primary-white, .single_add_to_cart_button, .ll-wocommerce .button, .button.wc-forward, .restore-item, .woocommerce-form-coupon .form-row-last button, .lost_reset_password .woocommerce-Button, .woocommerce-MyAccount-content a.button, .woocommerce button.button, .bag_sidebar-link a' )
            .on( 'mouseenter', function( e ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
              $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
            } )
            .on( 'mouseout', function( e ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
              $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
            } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'visual-form', COMPONENT );
} )( app );
